module.exports = __webpack_public_path__ + "img/product_mirrorreality.a09b52ab.png";